<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('distributorsSummaryReport.title') }}</h2>
      <p class="text-center mb-3 no-print">
        {{ $t('distributorsSummaryReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && reportData" class="row">
      <div class="col-6">
        <card :title="$t('distributorsSummaryReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorsSummaryReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.generated_at | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorsSummaryReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.from | dateOnly }} - {{
                  reportData.to | dateOnly
                }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorsSummaryReport.summary.totalPosesAmount') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ totalPosesAmount | money }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="reportData" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`distributorsSummaryReport.tableTitle`) }}
            <small v-if="reportData" class="ml-2 text-muted">({{ reportData.from | dateOnly }} - {{
                reportData.to | dateOnly
              }})</small>
          </h4>
          <el-table :data="reportData.data" :empty-text="$t('generic.emptyReportForThePeriod')"
                    show-summary :summary-method="getDistributorsSummaryTableTotal">
            <el-table-column :label="$t('distributorsSummaryReport.table.distributor_company_name')">
              <template slot-scope="{ row }">
                <div class="row m-0 p-0">
                  <div class="col m-0 p-0">
                    {{ row.distributor_company_name }}
                  </div>
                  <div class="col m-0 p-0" v-if="$auth.can({distributor: 'read'}, 'permissions')">
                    <router-link :to="distributorLink(row.distributor_id)">
                      <i class="mdi mdi_icon mdi-18px mdi-link no-print pr-2"></i>
                    </router-link>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('distributorsSummaryReport.table.committed_amount_sum')">
              <template slot-scope="{ row }">{{ row.committed_amount_sum | money }}</template>
            </el-table-column>
            <el-table-column :label="$t('distributorsSummaryReport.table.committed_transactions_count')">
              <template slot-scope="{ row }">{{ row.committed_transactions_count }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('distributorsSummaryReport.table.unfinished_transactions_count')">
              <template slot-scope="{ row }">
                <div class="row m-0 p-0">
                  <div class="col m-0 p-0">
                    {{ row.unfinished_transactions_count }}
                  </div>
                  <div class="col m-0 p-0 no-print" v-if="$auth.can({pos_transaction: 'delete'}, 'permissions')">
                    <base-button size="sm" type="danger" class="text-nowrap"
                                 :disabled="row.unfinished_transactions_count<=0 || bulkTxLoading"
                                 @click.native="handleCancelForce(row)">
                      <span
                          class="mdi mdi_icon mdi-18px mdi-close-circle-multiple-outline pr-2"/>{{
                        $t('distributorsSummaryReport.action.forceCancelBtnLabel')
                      }}
                    </base-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="right" width="50" class-name="no-print" label-class-name="no-print">
              <template slot-scope="{ row }">
                <router-link :to="distributorReportLink(row.distributor_id)">
                  <i class="tim-icons icon-double-right"></i>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert, BaseButton} from 'src/components';
import {mapActions, mapState} from "vuex";
import ReportFilter from "./ReportFilter";
import linkUtils from "@/util/link_utils";
import swal from 'sweetalert2';

export default {
  name: 'distributors-summary-report',
  components: {
    BaseAlert,
    BaseButton,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ReportFilter
  },
  data() {
    return {
      tickets: [],
      query: null,
    };
  },
  computed: {
    ...mapState({
      loading: state => state.distributors_summary_report.loading,
      reportData: state => state.distributors_summary_report.reportData,
      error: state => state.distributors_summary_report.error,
      bulkTxError: state => state.distributor_bulk_transactions.error,
      bulkTxLoading: state => state.distributor_bulk_transactions.loading,
    }),
    totalPosesAmount() {
      if (!this.reportData || !this.reportData.data || this.reportData.data.length == 0) {
        return 0
      }

      let total = 0;
      this.reportData.data.forEach((e) => {
        total = total + e.committed_amount_sum
      });

      return total;
    }
  },
  methods: {
    ...mapActions(['GetDistributorsSummaryReport', 'ForceDistributorsTransactionsCancel']),
    reloadReport(query) {
      this.query = query
      this.GetDistributorsSummaryReport(query);
    },
    distributorReportLink(distributorID) {
      return linkUtils.distributorReportPath(this.$router, {distributor_id: distributorID});
    },
    distributorLink(distributorID) {
      return linkUtils.distributorPath(this.$router, {id: distributorID});
    },
    getDistributorsSummaryTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('distributorsSummaryReport.table.totalSum');
          return;
        }
        if (index === 1 || index === 2 || index === 3) {
          let values;
          if (index === 1) {
            values = data.map(item => Number(item.committed_amount_sum));
          } else if (index === 2) {
            values = data.map(item => Number(item.committed_transactions_count));
          } else if (index === 3) {
            values = data.map(item => Number(item.unfinished_transactions_count));
          }

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }

          if (index === 1) {
            sums[index] = this.$options.filters['money'](sums[index])
          }

        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    handleCancelForce(row) {
      swal({
        title: this.$t('distributorsTransactions.forceCancel.title'),
        text: this.$t('distributorsTransactions.forceCancel.text', row),
        confirmButtonText: this.$t('distributorsTransactions.forceCancel.actionButton'),
        cancelButtonText: this.$t('distributorsTransactions.forceCancel.cancelButton'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.ForceDistributorsTransactionsCancel({
            period: this.query.period,
            distributor_id: row.distributor_id
          }).then(() => {
            if (this.bulkTxError == null) {
              this.$notify({
                type: 'success',
                message: this.$t('distributorsTransactions.forceCancel.deletedNotification', row),
                icon: 'tim-icons icon-alert-circle-exc'
              })
            } else {
              this.$notify({
                type: 'warning',
                message: this.bulkTxError,
                icon: 'tim-icons icon-alert-circle-exc'
              })
            }
          })
        }
      });
    },
  },
};
</script>

